import { render, staticRenderFns } from "./setting-currencies.vue?vue&type=template&id=3c95a63a&"
import script from "./setting-currencies.vue?vue&type=script&lang=ts&"
export * from "./setting-currencies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports